import type { TopClientRow } from './types'

function formatRub(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `₽ ${(n / 1_000_000).toFixed(1)}M`
  if (Math.abs(n) >= 1_000) return `₽ ${Math.round(n / 1_000)}K`
  return `₽ ${Math.round(n)}`
}

function categoryBadge(cat: 'A' | 'B' | 'C') {
  const cls =
    cat === 'A'
      ? 'bg-emerald-50 text-emerald-700'
      : cat === 'B'
        ? 'bg-blue-50 text-blue-700'
        : 'bg-gray-100 text-gray-600'
  return <span className={`inline-block px-1.5 rounded text-xs ${cls}`}>{cat}</span>
}

export function TopClientsTable({
  clients,
  onRowClick,
}: {
  clients: TopClientRow[]
  onRowClick?: (id: string) => void
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4">
      <div className="text-sm text-gray-500 mb-3">Топ клиентов</div>

      {clients.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Нет данных за период</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-gray-500">
              <th className="text-left font-normal pb-2">Клиент</th>
              <th className="text-center font-normal pb-2">Кат.</th>
              <th className="text-right font-normal pb-2">Сумма КП</th>
              <th className="text-right font-normal pb-2">Заявок</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c) => {
              const drop = c.momentumPercent !== null && c.momentumPercent <= -30
              return (
                <tr
                  key={c.id}
                  onClick={() => onRowClick?.(c.id)}
                  className={`border-t border-gray-100 ${drop ? 'bg-amber-50/40' : ''} ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
                >
                  <td className="py-2">
                    <span className="text-gray-900">{c.name}</span>
                    {drop && (
                      <span className="ml-1.5 inline-block px-1 rounded text-[10px] bg-amber-100 text-amber-800 tabular-nums">
                        {c.momentumPercent}%
                      </span>
                    )}
                  </td>
                  <td className="py-2 text-center">{categoryBadge(c.category)}</td>
                  <td className="py-2 text-right tabular-nums text-gray-700">
                    {formatRub(c.kpSumRub)}
                  </td>
                  <td className="py-2 text-right tabular-nums text-gray-600">{c.requestsCount}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </div>
  )
}
